// Mock data para o site da Dra. Nadja Offa

export const clinicInfo = {
  name: "Dra. Nadja Offa",
  profession: "Ortodontista",
  specialty: "Especialista em Ortodontia e Ortopedia Funcional dos Maxilares",
  rating: 5.0,
  reviewCount: 85,
  phone: "(11) 99720-3335",
  whatsapp: "5511997203335",
  address: "Av. Nossa Senhora do Ó, 865 - 16º andar - conjunto 1411 - Limão, São Paulo - SP",
  building: "Helbor Offices São Paulo 3",
  area: "Limão, Santana e regiões próximas",
  hours: "Aberto até 20:00",
  mapUrl: "https://maps.app.goo.gl/QLxGe6I9MWaWtlHvZ"
};

export const services = [
  {
    id: 1,
    title: "Ortodontia Infantil",
    description: "Aparelhos fixos e removíveis para correção do crescimento e alinhamento dental em crianças.",
    icon: "Smile"
  },
  {
    id: 2,
    title: "Alinhadores Invisíveis",
    description: "Tratamento ortodôntico discreto e moderno para adolescentes e adultos que buscam estética.",
    icon: "Sparkles"
  },
  {
    id: 3,
    title: "Ortopedia Funcional dos Maxilares",
    description: "Correção de problemas de crescimento dos maxilares em crianças de 5 a 12 anos.",
    icon: "Activity"
  },
  {
    id: 4,
    title: "Avaliação de Crescimento",
    description: "Avaliação ortodôntica do crescimento facial e desenvolvimento dentário.",
    icon: "LineChart"
  },
  {
    id: 5,
    title: "Tratamento de Má Oclusão",
    description: "Correção de mordida cruzada, mordida aberta, diastema e outras más oclusões.",
    icon: "CheckCircle2"
  },
  {
    id: 6,
    title: "Clareamento Dental",
    description: "Procedimentos de clareamento para um sorriso mais branco e bonito.",
    icon: "Star"
  },
  {
    id: 7,
    title: "Escaneamento Digital",
    description: "Moldagem digital 3D, sem uso de moldeiras tradicionais desconfortáveis.",
    icon: "Scan"
  },
  {
    id: 8,
    title: "Tratamento de Bruxismo",
    description: "Tratamento especializado para bruxismo infantil e proteção dental.",
    icon: "Shield"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ana Paula Silva",
    text: "Profissional muito atenciosa e competente. Minha filha tinha muito medo de dentista e a Dra. Nadja foi extremamente paciente e carinhosa. Hoje ela ama as consultas!",
    rating: 5,
    location: "Limão, SP"
  },
  {
    id: 2,
    name: "Roberto Oliveira",
    text: "Excelente experiência! Atendimento de alta qualidade e resultados incríveis. Recomendo muito!",
    rating: 5,
    location: "Santana, SP"
  },
  {
    id: 3,
    name: "Mariana Costa",
    text: "Melhor ortodontista da região! Tratamento personalizado e equipamentos modernos. Vale muito a pena!",
    rating: 5,
    location: "Casa Verde, SP"
  },
  {
    id: 4,
    name: "Felipe Santos",
    text: "Comecei meu tratamento com alinhadores invisíveis e estou adorando o resultado. Atendimento profissional e moderno.",
    rating: 5,
    location: "Santana, SP"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Com que idade devo levar meu filho ao ortodontista?",
    answer: "A primeira avaliação ortodôntica deve ser feita por volta dos 5 a 7 anos de idade. Nessa fase, é possível detectar problemas de crescimento dos maxilares e corrigir antes que se tornem mais graves. Quanto mais cedo identificarmos, mais simples e eficaz será o tratamento."
  },
  {
    id: 2,
    question: "O que é Ortopedia Funcional dos Maxilares?",
    answer: "É uma especialidade que trata o crescimento e desenvolvimento dos ossos da face durante a infância. Utilizamos aparelhos que estimulam ou redirecionam o crescimento ósseo, corrigindo problemas como mordida cruzada, retrognatismo e prognatismo de forma mais natural e menos invasiva."
  },
  {
    id: 3,
    question: "Como funcionam os alinhadores invisíveis?",
    answer: "Os alinhadores invisíveis são placas transparentes feitas sob medida que movimentam os dentes gradualmente. São praticamente imperceptíveis, removíveis para alimentação e higiene, e oferecem conforto superior aos aparelhos fixos tradicionais. Ideal para adolescentes e adultos que buscam discrição."
  },
  {
    id: 4,
    question: "O que é o escaneamento digital?",
    answer: "É uma tecnologia moderna que substitui as moldagens tradicionais. Utilizamos um scanner 3D que captura a forma dos dentes de forma rápida, confortável e precisa, sem necessidade de moldeiras com massa. É especialmente confortável para crianças."
  },
  {
    id: 5,
    question: "Como posso agendar uma consulta?",
    answer: "É muito fácil! Você pode agendar pelo WhatsApp (11) 99720-3335 ou através do formulário de agendamento aqui no site. Responderemos rapidamente e encontraremos o melhor horário para você."
  },
  {
    id: 6,
    question: "Meu filho tem medo de dentista. Como vocês lidam com isso?",
    answer: "Somos especializados em atendimento infantil e entendemos que muitas crianças têm medo. Utilizamos técnicas de adaptação gradual, ambiente acolhedor e uma abordagem gentil e paciente. A primeira consulta é focada em criar confiança e deixar a criança confortável."
  }
];

export const parentConcerns = [
  {
    id: 1,
    icon: "AlertCircle",
    title: "Medo do dentista",
    description: "Atendimento especializado e acolhedor para crianças ansiosas"
  },
  {
    id: 2,
    icon: "Utensils",
    title: "Problemas de mastigação",
    description: "Correção funcional para melhorar a alimentação e digestão"
  },
  {
    id: 3,
    icon: "MessageCircle",
    title: "Dificuldades na fala",
    description: "Tratamento ortodôntico que auxilia no desenvolvimento da fala"
  },
  {
    id: 4,
    icon: "Zap",
    title: "Mordida incorreta",
    description: "Correção de mordida cruzada, aberta e outras más oclusões"
  }
];

export const whyChoose = [
  {
    id: 1,
    title: "Especialista em Crianças",
    description: "Atendimento especializado e acolhedor para pacientes infantis, com técnicas de adaptação e ambiente amigável."
  },
  {
    id: 2,
    title: "Atendimento Personalizado",
    description: "Cada paciente é único. Desenvolvemos planos de tratamento individualizados para resultados excepcionais."
  },
  {
    id: 3,
    title: "Tecnologia Moderna",
    description: "Escaneamento digital 3D, alinhadores invisíveis e equipamentos de última geração."
  },
  {
    id: 4,
    title: "Excelência Comprovada",
    description: "5.0 estrelas com 85 avaliações. Reconhecida como referência em ortodontia na região."
  }
];

// Mock para sistema de agendamento
export const availableSlots = [
  { date: "2024-02-12", times: ["09:00", "10:00", "14:00", "15:00", "16:00"] },
  { date: "2024-02-13", times: ["09:00", "11:00", "14:00", "17:00", "18:00"] },
  { date: "2024-02-14", times: ["10:00", "11:00", "15:00", "16:00", "19:00"] },
  { date: "2024-02-15", times: ["09:00", "10:00", "14:00", "15:00", "17:00"] },
  { date: "2024-02-16", times: ["09:00", "11:00", "14:00", "16:00", "18:00"] }
];

export const appointmentTypes = [
  { id: "first", label: "Primeira Consulta", duration: "60 min" },
  { id: "followup", label: "Consulta de Retorno", duration: "30 min" },
  { id: "emergency", label: "Urgência", duration: "30 min" }
];
